module.exports = {
  __depends__: [
    require(110)
  ],
  __init__: [ 'bpmnKeyBindings' ],
  bpmnKeyBindings: [ 'type', require(9) ]
};